export const usersModule = 'users'
